import React, { useState } from 'react'
import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material'
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import TableItemMoreMenu from './TableItemMoreMenu'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

const CollapseItem = ({
  item,
  headers,
  getElement,
  rowActions,
  setInsideRow,
  defaultRowActions,
  onRowDelete,
  onRowEdit,
}: any) => {
  const [open, setOpen] = useState(false)
  const theme = useTheme()
  const { t } = useTranslation()

  const CollapseItemContainer = styled(Box)(({ theme }: any) => ({
    display: 'flex',
    pl: 3,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: 10,
    alignItems: 'center',
    borderBottom: '1px solid ' + theme.palette.grey['300'],
    mb: 0.5,
    marginBottom: 4,
    cursor: 'pointer',
    transition: '.2s ease all',
    '&:hover': {
      opacity: 0.7,
    },
  }))

  return (
    <>
      <CollapseItemContainer
        onClick={() => {
          setOpen(!open)
        }}
      >
        <IconButton size="small">
          {open ? (
            <KeyboardArrowUp sx={{ color: theme.palette.common.white }} />
          ) : (
            <KeyboardArrowDown sx={{ color: theme.palette.common.white }} />
          )}
        </IconButton>
        <Typography sx={{ ml: 2 }} variant="h6">
          {t(item?.category)} {':'} {item.key}
        </Typography>
      </CollapseItemContainer>
      <Collapse in={open} timeout={0} sx={{ pl: 4 }} unmountOnExit>
        <GroupCollapseInner
          onRowEdit={onRowEdit}
          onRowDelete={onRowDelete}
          defaultRowActions={defaultRowActions}
          rowActions={rowActions}
          setInsideRow={setInsideRow}
          getElement={getElement}
          headers={headers}
          row={item.data}
        />
      </Collapse>
    </>
  )
}

const GroupCollapseInner = ({
  row,
  headers,
  getElement,
  setInsideRow,
  rowActions,
  defaultRowActions,
  onRowEdit,
  onRowDelete,
}: any) => {
  return row?.[0]?.key ? (
    row?.map((r: any, i: number) => (
      <CollapseItem
        key={i}
        rowActions={rowActions}
        setInsideRow={setInsideRow}
        getElement={getElement}
        headers={headers}
        item={r}
        onRowEdit={onRowEdit}
        onRowDelete={onRowDelete}
        defaultRowActions={defaultRowActions}
      />
    ))
  ) : (
    <TableContainer sx={{ bgcolor: 'white', my: 4, borderRadius: 2 }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {headers?.map((head: any, index: number) => (
              <TableCell key={index}>
                {headers.find((r: any) => r.id === head.id)?.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {row?.map((row: any, index: number) => {
            return (
              <TableRow key={index}>
                {headers?.map((headCell: any, s_index: number) =>
                  getElement(headCell, s_index, row),
                )}
                <TableCell align="right">
                  <TableItemMoreMenu
                    setInsideRow={setInsideRow}
                    onRowEdit={onRowEdit}
                    onRowDelete={onRowDelete}
                    row={row}
                    rowIndex={index}
                    rowActions={rowActions}
                    defaultRowActions={defaultRowActions}
                  />
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

const GroupCollapse = ({
  open,
  headers,
  insideRow,
  getElement,
  setInsideRow,
  rowActions,
  defaultRowActions,
  onRowEdit,
  onRowDelete,
}: any) => {
  const theme = useTheme()
  return (
    <TableRow>
      <TableCell sx={{ padding: 0, bgcolor: '#f7f7f7' }} colSpan={12}>
        <Collapse in={open} timeout={0} sx={{ pl: 5 }} unmountOnExit>
          <Box sx={{ py: 2 }}>
            <GroupCollapseInner
              getElement={getElement}
              headers={headers}
              setInsideRow={setInsideRow}
              row={insideRow.data}
              rowActions={rowActions}
              onRowEdit={onRowEdit}
              onRowDelete={onRowDelete}
              defaultRowActions={defaultRowActions}
            />
          </Box>
        </Collapse>
      </TableCell>
    </TableRow>
  )
}

export default GroupCollapse
